<template>
  <v-card class="elevation-1">
    <loading-component :value="loading" />
    <v-card-title primary-title class="font-weight-bold title">
      {{ $t("monitoring.createFollowUpTicket.reportingAProblem") }}
    </v-card-title>
    <v-card-text>
      <v-form ref="form">
        <v-select
          :label="$t('monitoring.createFollowUpTicket.whoAreYouReporting')"
          :items="reportOnItems"
          :rules="[required]"
          v-model="report_on"
        />

        <template>
          <choose-captains-multi
            v-if="report_on === 'CAPTAIN'"
            :label="$t('monitoring.createFollowUpTicket.chooseCaptain')"
            :multi="false"
            :rules="[required]"
            v-model="captain_id"
          />

          <choose-passenger-multi
            v-if="report_on === 'PASSENGER'"
            :label="$t('monitoring.createFollowUpTicket.choosePassenger')"
            :rules="[required]"
            :multi="false"
            v-model="passenger_id"
          />
        </template>

        <v-textarea
          v-if="report_on && (passenger_id || captain_id)"
          v-model="data"
          :label="$t('monitoring.createFollowUpTicket.describeYourProblem')"
          :rules="[required]"
        />

        <v-switch
          v-if="data"
          v-model="assign_to_user"
          :label="$t('monitoring.createFollowUpTicket.assignToSpecificUser')"
          color="red"
        />

        <choose-user-multi
          :multi="false"
          v-if="assign_to_user"
          v-model="user_id"
          :label="$t('monitoring.createFollowUpTicket.chooseUserToAssign')"
          color="green"
          :rules="[required]"
        />
      </v-form>

      <v-btn large flat color="primary" @click="save"> {{ $t("monitoring.createFollowUpTicket.send") }} </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import ChooseCaptainsMulti from "@/components/monaco/input/ChooseCaptainMulti";
import ChoosePassengerMulti from "@/components/monaco/input/ChoosePassengerMulti";
import ChooseUserMulti from "@/components/monaco/input/ChooseUserMutli";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "create-follow-up-ticket",
  components: {
    LoadingComponent,
    ChooseUserMulti,
    ChoosePassengerMulti,
    ChooseCaptainsMulti,
  },
  data() {
    return {
      report_on: null,
      captain_id: null,
      passenger_id: null,
      data: null,
      assign_to_user: false,
      user_id: null,
      loading: false,
    };
  },
  computed: {
    reportOnItems() {
      return [
        { text: this.$t("monitoring.createFollowUpTicket.passenger"), value: "PASSENGER" },
        { text: this.$t("monitoring.createFollowUpTicket.captain"), value: "CAPTAIN" },
      ];
    },
    required() {
      return (val) => !!val || this.$t("monitoring.createFollowUpTicket.fieldRequired");
    },
    follow_up_ticket() {
      return {
        id: this.$store.state.user.settings.FOLLOW_UP_TICKET.id,
        last_question_id:
          this.$store.state.user.settings.FOLLOW_UP_TICKET.last_question_id,
        last_field_id:
          this.$store.state.user.settings.FOLLOW_UP_TICKET.last_field_id,
      };
    },
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      try {
        const result = await this.axios.post(this.api.ACTIONS.TICKETS, {
          ticket_type_id: this.follow_up_ticket.id,
          last_question_id: this.follow_up_ticket.last_question_id,
          answers: {
            [`question_${this.follow_up_ticket.last_field_id}`]: this.data,
          },
          [this.report_on === "PASSENGER" ? "passenger_id" : "captain_id"]:
            this.captain_id || this.passenger_id,
          ...(this.assign_to_user
            ? {
                user_id: this.user_id,
              }
            : {}),
        });
        window.getApp.$emit("SHOW_TOAST", this.$t("monitoring.createFollowUpTicket.ticketSaved"), "green");
        this.$emit("saved");
      } catch (e) {
        window.getApp.$emit("SHOW_TOAST", e, "red");
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    report_on() {
      this.captain_id = null;
      this.passenger_id = null;
      this.data = null;
      this.assign_to_user = false;
    },
    assign_to_user() {
      this.user_id = null;
    },
  },
};
</script>

<style scoped></style>
